/**
 * Shared constants for pawn positioning within Base components
 *
 * These constants define the sizing and positioning for pawns rendered
 * inside Base components. All values are based on the Base SVG viewBox
 * dimensions (0 0 486 523) and pawn viewBox dimensions (0 0 323 473).
 */

/**
 * Pawn sizing configuration
 * Scale factor for pawns to be 22.5% of base width (109px for viewBox 486)
 * Calculation: 109px / 323px = 0.337
 */
export const PAWN_SCALE = 0.337;

/**
 * Native pawn dimensions from Pawn component viewBox (0 0 323 473)
 */
export const NATIVE_PAWN_WIDTH = 323;
export const NATIVE_PAWN_HEIGHT = 473;

/**
 * Pre-calculated offsets for centering pawns on spot circles
 * These values center the pawn's origin (0,0) on the spot circle center
 */
export const PAWN_OFFSET_X = (NATIVE_PAWN_WIDTH * PAWN_SCALE) / 2; // ~54.4
export const PAWN_OFFSET_Y = (NATIVE_PAWN_HEIGHT * PAWN_SCALE) / 2; // ~79.7

/**
 * Spot circle centers from Base SVG (cx, cy of pawn spot circles)
 * These positions are identical across all 4 base colors
 *
 * Grid layout:
 * ┌─────────┬─────────┐
 * │ pawn1   │ pawn2   │  Top row
 * ├─────────┼─────────┤
 * │ pawn3   │ pawn4   │  Bottom row
 * └─────────┴─────────┘
 */
export const PAWN_POSITIONS = {
  pawn1: { cx: 150, cy: 120 }, // Top-left
  pawn2: { cx: 290, cy: 120 }, // Top-right
  pawn3: { cx: 150, cy: 260 }, // Bottom-left
  pawn4: { cx: 290, cy: 260 } // Bottom-right
} as const;

/**
 * Type for pawn position keys
 */
export type PawnPositionKey = keyof typeof PAWN_POSITIONS;

/**
 * Shared color constants used across all Base components
 */
export const SHARED_COLORS = {
  frame: '#A4D229', // Lime-green outer frame (all bases)
  shadow: '#000', // Shadow color (all bases)
  grassGreen: '#69AA3F' // Decorative grass elements (all bases)
} as const;
